// The single source of truth for "what domain should absolute URLs use."
//
// Why this exists: react-snap prerenders the site by spinning up a
// temporary local server (something like http://localhost:45678) and
// pointing headless Chrome at it to capture each route's rendered HTML.
// During that crawl, window.location.origin genuinely IS that local
// address, not martleystrategy.com.
//
// This function returns PRODUCTION_ORIGIN whenever the site is being
// prerendered, served locally, or hosted on local dev ports, ensuring
// frozen static build files ALWAYS reference the real HTTPS domain.

const PRODUCTION_ORIGIN = "https://martleystrategy.com";

export function getPublicOrigin() {
  if (typeof window === "undefined" || !window.location) {
    return PRODUCTION_ORIGIN;
  }

  const { hostname, origin } = window.location;

  // If running on localhost, 127.0.0.1, or anything that isn't live martleystrategy.com,
  // return the production origin so react-snap bakes valid absolute URLs into builds.
  if (
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname.includes("localhost") ||
    !hostname.includes("martleystrategy.com")
  ) {
    return PRODUCTION_ORIGIN;
  }

  return origin;
}